<template>
  <div class="news-admin-page">
    <StateWrapper
      :content="data.news"
      :loadingStatus="loadingStatus"
      :checkLogin="false"
    >
      <AdminPageTitle :title="'Статьи'" class="mt-10"/>
      <div class="wrapper">
      <v-row>
       <AppButton
                v-if="!showNewsForm"
                @click="showNewsForm=true"
                class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
              >
                <span>Добавить</span>
              </AppButton>

              <AppButton
                v-if="!showNewsForm"
                @click="router.push({ path: '/admin/news_tag' });"
                class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
              >
                <span>Ярлыки</span>
              </AppButton>
      </v-row>

        <div v-if="showNewsForm">
          <v-card>
            <v-card-title class="card_ligth_header">
              <h5 v-if="!!this.id">Редактирование статьи</h5>
              <h5 v-else>Добавление статьи</h5>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <v-form ref="newsForm">
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Заголовок*"
                        v-model="title"
                        :counter="250"
                        variant="outlined"
                        hint="Укажите заголовок"
                        required
                      ></v-text-field>
                      <div
                        class="input-errors"
                        v-for="error of v$.title.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg form__tip form__tip--error showing">
                          {{ error.$message }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12">
                      <v-textarea
                        label="Краткий анонс для главной*"
                        v-model="newsAnnotation"
                        :counter="1500"
                        variant="outlined"
                        hint="Укажите анонс"
                        required
                      ></v-textarea>
                      <div
                        class="input-errors"
                        v-for="error of v$.newsAnnotation.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg form__tip form__tip--error showing">
                          {{ error.$message }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" class="mb-16" style="height: 1200px;">
                      <TextEditor class="mb-3" :value="newsContent" @update:value="onNewsContentUpdate" />
                      <div
                        class="input-errors"
                        v-for="error of v$.newsContent.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg form__tip form__tip--error showing">
                          {{ error.$message }}
                        </div>
                      </div>
                    </v-col>
                    <v-col cols="12" class="mt-12">
                      <v-label>Дата публикации*</v-label>
                      <datePicker
                        v-model="publDateTime"
                        locale="ru"
                        auto-apply
                      />
                    </v-col>
                    <v-col cols="12" class="mt-4">
                      <v-label>Статус публикации*</v-label>
                      <v-row class="px-4" fluid>
                        <v-switch
                          v-model="published"
                          color="success">
                        </v-switch>
                        <v-chip class="ma-2" v-if="published"> Опубликовано</v-chip><v-chip v-else class="ma-2"> Не опубликовано</v-chip>
                      </v-row>
                    </v-col>
                    <v-col cols="12" class="py-16">
                      <v-autocomplete
                        v-model="videoFiles"
                        :items="sourceVideos"
                        clearable
                        return-object
                        multiple
                        outlined
                        dense
                        small-chips
                        chips
                        closable-chips
                        item-title="videoDescription"
                        label="Видео"
                        v-on:click:clear="videoFiles = []"
                      >
                        <template v-slot:chip="{ props, item }">
                          <v-chip
                            v-bind="props"
                            :text="item.raw.videoDescription && item.raw.videoDescription.length>30 ? item.raw.videoDescription.substring(0, 28) + '...' : item.raw.videoDescription"
                          ></v-chip>
                        </template>
                        <template v-slot:item="{ props, item }">
                          <v-list-item
                            v-bind="props"
                            :title="item.raw.videoDescription"
                          ></v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12">
                      <v-text-field
                        label="Источник*"
                        v-model="sourceUrl"
                        :counter="250"
                        variant="outlined"
                        hint="Укажите источник"
                        required
                      >
                      </v-text-field>
                      <div
                        class="input-errors"
                        v-for="error of v$.sourceUrl.$errors"
                        :key="error.$uid"
                      >
                        <div class="error-msg form__tip form__tip--error showing">
                          {{ error.$message }}
                        </div>
                      </div>
                    </v-col>
                     <v-col cols="12">
                                    <v-autocomplete
                                        v-model="experts"
                                        :items="expertsInSystem"
                                        outlined
                                        dense
                                        chips
                                        small-chips
                                        multiple
                                        closable-chips
                                        item-title="firstname"
                                        return-object
                                        label="Эксперты"
                                    >
                                      <template v-slot:chip="{ props, item }">
                                        <v-chip
                                            v-bind="props"
                                            :text="item.raw.firstname +' '+item.raw.lastname"
                                        ></v-chip>
                                      </template>
                                      <template v-slot:item="{ props, item }">

                                        <v-list-item
                                            v-bind="props"
                                            :title="item.raw.firstname +' '+item.raw.lastname"
                                            :subtitle="item.raw.username"
                                        ></v-list-item>
                                      </template>
                                    </v-autocomplete>
                                  </v-col>
                    <v-col>
                      <v-autocomplete
                        v-model="newsTags"
                        :items="activeNewsTags"
                        outlined
                        auto-select-first
                        dense
                        clearable
                        v-on:click:clear="newsTags =[]"
                        chips
                        small-chips
                        multiple
                        variant="outlined"
                        label="Ярлыки"
                      >
                        <template v-slot:chip="{ props, item }">
                          <v-chip
                            v-bind="props"
                            :text="item.raw.tagName"
                          ></v-chip>
                        </template>
                        <template v-slot:item="{ props, item }">
                          <v-list-item
                            v-bind="props"
                            :title="item.raw.tagName"
                          ></v-list-item>
                        </template>
                      </v-autocomplete>
                    </v-col>

                  </v-row>
                  <v-row>
                        <v-col cols="12" md="4">
                          <v-number-input
                            v-model="importance"
                            label="Важность (чем больше - тем важнее)"
                            :min="0"
                            :max="100"
                            :step="1"
                          ></v-number-input>
                        </v-col>
                      </v-row>
                </v-container>
                <small>*обязательно для заполнения</small>
              </v-form>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="card_ligth_actions">
              <v-spacer></v-spacer>
              <AppButton
                class="admin-lib__opener d-flex flex__ai-c"
                @click="closeNewsForm"
              >
                <span>Отмена</span>
              </AppButton>
              <AppButton
                class="admin-lib__opener d-flex flex__ai-c"
                @click="saveNews"
                :disabled="saveIsDisable"
              >
                <span>Сохранить</span>
              </AppButton>
            </v-card-actions>
          </v-card>
        </div>
        <div v-else class="news-admin-page__results">
          <div class="news-admin-page__items" v-if="data.news">
            <AccordionItemWithEdit
              v-for="(v, idx) in data.news"
              :key="v.id"
              :isOpen="currentId === v.id"
              @open="setCurrentId"
              :style="{ 'animation-delay': `0.${idx}s` }"
              :id="v.id"
            >
              <template v-slot:top>
                <span v-if="v.title">{{ v.title }} <span v-if="!!v.createDateTime">({{ formatDate(v.createDateTime) }})</span></span>
              </template>
              <template v-slot:bottom>
                <div class="ma-2">

                  <h3>Анонс:</h3>
                  <div class="news-admin-page__chips" v-html="v.newsAnnotation">
                  </div>
                </div>


                <div v-if="v.videoFiles && v.videoFiles.length">
                  <h3>Видео:</h3>
                  <SalonVideoPreview
                    v-for="(e, idx) in v.videoFiles"
                    :key="idx"
                    :videoFile="e"
                    @selectVideo="selectVideo"
                  />
                </div>
                <div v-if="v.newsTags && v.newsTags.length>0" class="ma-2">
                  <h3>Ярлыки:</h3>
                  <div class="help-page__chips">
                    <span v-for="c in v.newsTags" :key="c.id">{{c.tagName}}</span>
                  </div>
                </div>

                <v-divider color="accent" class="mt-8"></v-divider>
                <div class="ma-2">
                  <v-row>
                    <v-spacer></v-spacer>
                    <AppButton
                      @click="deleteNews(v)"
                      class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                    >
                      <span>Удалить</span>
                    </AppButton>
                    <AppButton
                      @click="editNews(v)"
                      class="app-button n-admin-cource__add mt-8 mb-4 ml-4 mr-4"
                    >
                      <span>Редактировать</span>
                    </AppButton>
                  </v-row>
                </div>
              </template>
            </AccordionItemWithEdit>
          </div>
          <div class="flex flex__jc-c" v-if="!!data && data.news">
            <vue-awesome-paginate
              :total-items="data.newsCount"
              v-model="currentPage"
              :items-per-page="itemsPerPage"
              :max-pages-shown="maxPagesShown"
              @click="updateNews()"
            />
          </div>
        </div>
      </div>
    </StateWrapper>
    <NVideoModal
      v-if="showVideo"
      :video="video"
      @closeModal="closeVideoModal"
    />
  </div>
</template>
<script>
  import TextEditor from "@/components/TextEditor.vue";
  import { useRouter } from "vue-router";
  import NVideoModal from "@/components/NVideoModal.vue";
  import SalonVideoPreview from "@/components/SalonVideoPreview.vue";
  import { onMounted, ref, computed } from "vue";
  import { t } from "@/utils/translate";
  import { customAxios } from "@/service/customAxios";
  import AccordionItemWithEdit from "@/components/AccordionItemWithEdit.vue";
  import AdminPageTitle from "@/elements/AdminPageTitle.vue";
  import StateWrapper from "@/components/StateWrapper.vue";
  import { setCurrentIdValue } from "@/utils/common";
  import AppButton from "@/elements/AppButton.vue";
  import { required, maxLength, helpers } from "@vuelidate/validators";
  import useVuelidate from "@vuelidate/core";
  import { usePopupStore } from "@/store/popupStore";
  import { VNumberInput } from 'vue-number-input'

  export default {
    components: {
      StateWrapper,
      AdminPageTitle,
      AccordionItemWithEdit,
      AppButton,
      TextEditor,
      NVideoModal,
      SalonVideoPreview,
      VNumberInput
    },
    setup() {
      const router = useRouter();
      const title = ref("");
      const news = ref([]);
      const newsTags = ref([]);
      const activeNewsTags = ref([]);
      const newsAnnotation = ref("");
      const newsContent = ref("");
      const published = ref(false);
      const sourceUrl = ref("");
      const showNewsForm = ref(false);
      const publDateTime = ref(new Date().toJSON());
      const id = ref("");
      const errorBody = ref("");
      const { showPopup } = usePopupStore();
      const sourceVideos = ref([]);
      const videoFiles = ref([]);
      const video = ref('');
      const showVideo = ref(false);
      const experts = ref([]);
      const expertsInSystem = ref([]);
      const importance = ref(0);

      const rules = {
        title: {
          required: helpers.withMessage("Обязательное поле", required),
          max: helpers.withMessage("Не более 250 символов", maxLength(250)),
        },
        newsAnnotation: {
          required: helpers.withMessage("Обязательное поле", required),
          max: helpers.withMessage("Не более 1500 символов", maxLength(1500)),
        },
        newsContent: {
          required: helpers.withMessage("Обязательное поле", required),
        },
        sourceUrl: {
          required: helpers.withMessage("Обязательное поле", required),
          max: helpers.withMessage("Не более 250 символов", maxLength(250)),
        },
        publDateTime: {
          required: helpers.withMessage("Обязательное поле", required),
        },
      };

      const v$ = useVuelidate(rules, {
        title: title,
        newsAnnotation: newsAnnotation,
        newsContent: newsContent,
        sourceUrl: sourceUrl,
        publDateTime: publDateTime,
      });

      const loadingStatus = ref("loading");
      const currentId = ref(null);
      const data = ref([]);
      const maxPagesShown = ref(5);
      const itemsPerPage = ref(25);
      const currentPage = ref(1);
      function onNewsContentUpdate(e) {
        console.log("Content updated")
        newsContent.value = e;
      }

      function setCurrentId(value) {
        currentId.value = setCurrentIdValue(value, currentId.value);
      }

      const saveIsDisable = computed(() => {
        return checkInvalidation();
      });

      function checkInvalidation() {
        v$.value.$touch();
        return v$.value.$invalid;
      }
      function formatDate(dateString) {
        let formatter = new Intl.DateTimeFormat("ru", {
          weekday: "long",
          year: "numeric",
          month: "long",
          day: "numeric",
        });
        return capitalizeFirstLetter(formatter.format(Date.parse(dateString)));
      }

      async function updateNews(){
        data.value = await getNews();
        news.value = data.value.news;
      }

      async function getVideos() {
        try {
          let r = await customAxios.get("library/video");
          if (r.status === 200) {
            sourceVideos.value = r.data
          }
          loadingStatus.value = "loaded";
        } catch (e) {
          loadingStatus.value = "error";
          console.log(e);
        }
      }

      async function getNewsTags() {
        try {
          const r = await customAxios.get("news/tag/published");
          if (r.status === 200) {
            loadingStatus.value = "loaded";
            activeNewsTags.value = r.data;
          }
        } catch (e) {
          loadingStatus.value = "error";
          console.log(e);
        }
      }
      function closeVideoModal() {
        showVideo.value = false;
        video.value = null;
      }

      function selectVideo(v) {
        video.value = v;
        showVideo.value = true;
      }
      async function getNews() {
           loadingStatus.value = "loading";
        try {
          const r = await customAxios.post("news/paginated",{
            page: currentPage.value,
            notePerPage: itemsPerPage.value,
          });
          loadingStatus.value = "loaded";
          return r.data;
        } catch (e) {
          loadingStatus.value = "error";
          console.log(e);
        }
      }
      function capitalizeFirstLetter(string) {
        if(string && string.length>0){
          return string.charAt(0).toUpperCase() + string.slice(1);
        } else {
          return ''
        }
      }

      function editNews(item){
        id.value=item.id;
        title.value=item.title;
        newsAnnotation.value=item.newsAnnotation;
        newsContent.value=item.newsContent;
        published.value=item.published;
        sourceUrl.value=item.sourceUrl;
        publDateTime.value = item.publDateTime;
        newsTags.value = item.newsTags;
        videoFiles.value = item.videoFiles;
        experts.value = item.experts;
        importance.value = item.importance;
        showNewsForm.value = true;

      }

      function closeNewsForm(){
        id.value="";
        title.value="";
        newsAnnotation.value="";
        newsContent.value="";
        published.value=false;
        experts.value = [];
        sourceUrl.value="";
        publDateTime.value=(new Date().toJSON())
        showNewsForm.value = false;
        videoFiles.value = [];
        newsTags.value = [];
        importance.value = 0;
      }

      async function saveNews() {
        errorBody.value=''
        let news = {
          title: capitalizeFirstLetter(title.value),
          newsAnnotation: capitalizeFirstLetter(newsAnnotation.value),
          newsContent: newsContent.value,
          published: published.value,
          sourceUrl: sourceUrl.value,
          publDateTime: publDateTime.value,
          newsTags: newsTags.value,
          videoFiles: videoFiles.value,
          experts: experts.value,
          importance: importance.value,
        }
        if (id.value) {
          try{
            const r = await customAxios.put('news/' + id.value, news)
            if(r.status===202){
              closeNewsForm();
              updateNews();
              showPopup("Новость успешно обновлена!", "success");
            }
          } catch (e) {
            if(e.response && e.response.data && e.response.data.message){
              errorBody.value = e.response.data.message;
            } else {
              errorBody.value = t("something.went.wrong");
            }
          }
        } else {
          try{
            const r = await  customAxios.post('news', news);
            if(r.status===201){
              closeNewsForm();
              updateNews();
              showPopup("Новость успешно добавлена!", "success");
            }
          } catch(e){
            if(e.response && e.response.data && e.response.data.message){
              errorBody.value = e.response.data.message;
            } else {
              errorBody.value = t("something.went.wrong");
            }
          }
        }
      }

      async function getExperts() {
         try {
          const r = await customAxios.post("person/experts/paginated",{
            page: currentPage.value,
            notePerPage: itemsPerPage.value,
          });
              if (r.status === 200) {
                  expertsInSystem.value = r.data.persons;
              data.value = r.data;
              }
              loadingStatus.value = "loaded";

        } catch (e) {
          loadingStatus.value = "error";
          console.log(e);
        }
      }
      async function deleteNews(news){
        try {
          const r = await customAxios.delete('news/' + news.id)
          console.log("r: " + r);
          if(r.status===202){
            showPopup(r.data.message, "success");
            updateNews();
          }
        } catch (e) {
          if(e.response && e.response.data && e.response.data.message){
            showPopup(e.response.data.message, "error");
          } else {
            showPopup(t("something.went.wrong"), "error");
          }
        }
      }

      onMounted(async () => {
        data.value = await getNews();
      });
      onMounted(async () => {
        await getNewsTags();
      });

      onMounted(async () => {
        await getVideos();
      });

      onMounted(async () => {
        await getExperts();
      });

      return {
        loadingStatus,
        itemsPerPage,
        currentPage,
        maxPagesShown,
        data,
        news,
        t,
        updateNews,
        setCurrentId,
        currentId,
        title,
        newsAnnotation,
        newsContent,
        published,
        sourceUrl,
        showNewsForm,
        id,
        activeNewsTags,
        newsTags,
        videoFiles,
        sourceVideos,
        editNews,
        deleteNews,
        closeNewsForm,
        saveNews,
        capitalizeFirstLetter,
        rules,
        v$,
        saveIsDisable,
        errorBody,
        formatDate,
        publDateTime,
        onNewsContentUpdate,
        router,
        closeVideoModal,
        selectVideo,
        video,
        showVideo,
        experts,
        expertsInSystem,
        importance
      };
    },
  };
</script>
  <style lang="scss">
  .news-admin-page {


    &__chips {
      margin-top: 5px;
      display: flex;
      flex-wrap: wrap;

      span {
        color: $accent-1;
        border: 1px dashed $accent-1;
        padding: 8px;
        margin: 8px;
        border-radius: 10px;
      }
    }

    &__filters {
      text-align: left;
      margin-bottom: 60px;
    }

    &__filters-title {
      margin-bottom: 10px;
    }

    &__theme {
      @include button-default-not-accent;
      display: none;
      margin-right: 8px;

      &.active {
        display: flex;
      }

      &.current {
        background-color: $accent-1;
        color: #fff;
      }
    }

    &__search {
      margin-bottom: 60px;
    }

    .wrapper {
      @include page;
    }
    ul{
      margin-left: 40px;
    }

    &__items {
      display: grid;
      grid-template-columns: 1fr;
      grid-gap: 40px;
      width: 100%;
      margin: 0 auto;
      margin-top: 30px;
    }

    &__btn {
      @include button-default-not-accent;

      &.active {
        @include button-default;
      }

      & + .news-admin-page__btn {
        margin-left: 16px;
      }
    }
  }
  </style>

